import { EMPTY_FN } from '@libs/shared';

/**
 * 为节点绑定事件监听器并返回解绑方法
 *
 * @param target
 * @param type
 * @param listener
 * @param options
 */
export const bindListener = (
    target: EventTarget | undefined,
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions
) => {
    if (target) {
        target.addEventListener(type, listener, options);
        return () => {
            target.removeEventListener(type, listener, options);
        };
    }
    return EMPTY_FN;
};

// 获取默认的滚动条大小
let scrollbarSize: { width: number; height: number } = { width: 0, height: 0 };
export const getScrollbarSize = () => {
    // 如果之前计算过，则直接返回全局缓存的计算结果，避免重复计算
    if (scrollbarSize.width && scrollbarSize.height) {
        return scrollbarSize;
    }
    const scrollDiv = document.createElement('div');

    scrollDiv.style.position = 'absolute';
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.top = '-9999px';

    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    const scrollbarHeight = scrollDiv.offsetHeight - scrollDiv.clientHeight;
    document.body.removeChild(scrollDiv);
    scrollbarSize = { width: scrollbarWidth, height: scrollbarHeight };

    return scrollbarSize;
};

export const isDomElement = (el: any) => {
    return el instanceof Node || el instanceof NodeList;
};

/**
 * 获取最近节点
 *
 * @param $el
 * @param selector
 * @returns
 */
export const closest = ($el: any, selector: any): null | HTMLElement => {
    if (!isDomElement($el)) {
        return null;
    }

    if ($el.closest) {
        return $el.closest(selector);
    }

    const matchesSelector =
        $el.matches || $el.webkitMatchesSelector || $el.mozMatchesSelector || $el.msMatchesSelector;
    let $element = $el;

    while ($element) {
        if (matchesSelector.call($element, selector)) {
            return $element;
        }
        $element = $element.parentElement;
    }
    return null;
};
